<template>
	<div class="learner_dashboard learner_profile" aria-label="Learner Profile Page">
<!-- Personal Info -->
    <div class="personal_info card crd_sty_3">
      <div class="row pg_sec_head align-items-center">
        <div class="col"></div>
        <div class="col-auto text-right">
          <button class="btn" @click="showContactInfoModal">
            {{ $t('updateContactInformation') }}
          </button>
          <button type="button" class="btn align-middle ml-2" @click="showChangePasswordModal">
            {{ $t('changePassword') }}
          </button>
        </div>
      </div>
      <div class="row pg_sec_content">
        <div class="col-12">
          <div class="row">
            <div class="col-2">
              <div class="row">
                <div class="col-11 thumbnail_container">
                  <div class="thumbnail_default usr_thumbnail_lg">
                    <div class="ic ic9-user"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col pl-0">
              <div class="row fld_row">
                <div class="col-11 fld_label fld_name">
                  {{ userName }}
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-11 fld_label">
                  <span class="icon-mail2" aria-hidden="true"></span>  {{ email }}
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-11 fld_label">
                  <span class="icon-phone" aria-hidden="true"></span>  {{ phone }}
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-11 fld_label">
                  <span class="icon-linkedin" aria-hidden="true"></span>  {{ linkedIn }}
                </div>
              </div>
              <div class="row fld_row">
                <div class="col-11 fld_label">
                  <span class="icon-location" aria-hidden="true"></span>  {{ address }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- End Personal Info -->
<!-- Resume -->
		<div class="row">
			<div class="col-12">
				<learner-profile-resume ref="learnerProfileResume" :uuid="uuid" v-if="isResumeUploadEnabled" @show-visibility-modal="showVisibilityModal"></learner-profile-resume>
			</div>
		</div>
<!-- End Resume -->

<!-- Experience -->
    <template v-if="isEditExperienceEnabled">
      <div class="card crd_sty_3">
        <div class="row pg_sec_head">
          <div class="col-10">
            <div class="hd_txt">
              {{ $t('experience') }}
            </div>
          </div>
          <div class="col-2 lnk_container">
            <span>
              <b-btn @click="addExperienceClicked">
                {{ $t('add') }}
              </b-btn>
            </span>
            <span class="visibility-btn icon-eye" @click="showVisibilityModal('Experiences', false)" v-if="formattedPerson.experienceVisibleToEmployer" title="Visible to Employer">
            </span>
            <span class="visibility-btn icon-eye-blocked" @click="showVisibilityModal('Experiences', true)" v-else title="Not Visible to Employer">
            </span>
          </div>
        </div>

      <div class="row section_row">
	    	<div class="col-12 section_content">
	    		<template v-if="formattedPerson.experienceInfoList && formattedPerson.experienceInfoList.length && formattedPerson.experienceInfoList.length > 0">
		    		<div class="row">
            	<div id="personExperience" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" v-for="experience in formattedPerson.experienceInfoList">
            		<div class="row">
	                <div class="col-12 col_txt_row hd" v-if="experience.title">
	                	<span class="title">
											{{ $t('title') }}:
											{{experience.title}}
										</span>
	                	<button
											@click="editExperience(experience)"
											class="btn btn_ic icon-pencil"
											:aria-label="$t('editAria')"
											:title="$t('editTitle')"
                      v-b-tooltip.hover>
										</button>
	                	<button
											@click="removeItemFromList(formattedPerson.experienceInfoList, experience)"
											class="btn btn_ic icon-bin"
											:aria-label="$t('deleteAria')"
											:title="$t('deleteTitle')"
                      v-b-tooltip.hover>
										</button>
	                </div>
	                <div class="col-12 col_txt_row" v-if="experience.description">
										{{ $t('description') }}:
										{{ experience.description }}
										</div>
	                <div class="col-12 col_txt_row" v-if="experience.employer">
										{{ $t('employer') }}:
										{{ experience.employer }}
									</div>
	                <div class="col-12 col_txt_row" v-if="experience.industry">
										{{ $t('industry') }}:
										{{ experience.industry }}
									</div>
	                <div class="col-12 col_txt_row" v-if="experience.location">
										{{ $t('location') }}:
										{{ experience.location }}
									</div>
	                <div class="col-12 col_txt_row" v-if="experience.experienceTimeLabel">
										{{ $t('duration') }}:
										{{ experience.experienceTimeLabel }}
									</div>
                </div>
            	</div>
          	</div>
          </template>
          <template v-if="formattedPerson.experienceInfoList && formattedPerson.experienceInfoList.length === 0">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col">
                <p class="text-center">
									{{ $t('addExperienceMsg') }}
								</p>
              </div>
            </div>
          </template>

	    	</div> <!-- section_content -->
	    </div> <!-- section_row -->
      </div>
    </template>
<!-- Experience Ends -->

<!-- Education -->
    <template v-if="isEditEducationEnabled">
      <div class="card crd_sty_3">
        <div class="row pg_sec_head">
          <div class="col-10">
            <div class="hd_txt">
              {{ $t('education') }}
            </div>
          </div>
          <div class="col-2 lnk_container">
            <b-btn @click="addEducationClicked">
              {{ $t('add') }}
            </b-btn>
            <span class="visibility-btn icon-eye" @click="showVisibilityModal('Educations', false)" v-if="formattedPerson.educationVisibleToEmployer" title="Visible to Employer">
            </span>
            <span class="visibility-btn icon-eye-blocked" @click="showVisibilityModal('Educations', true)" v-else title="Not Visible to Employer">
            </span>
          </div>
        </div>
        <div class="row section_row">
          <div class="col-12 section_content">
            <template v-if="formattedPerson.educationInfoList && formattedPerson.educationInfoList.length && formattedPerson.educationInfoList.length > 0">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" id="personEducation" v-for="education in formattedPerson.educationInfoList">
                  <div class="row">
                    <div class="col-12 col_txt_row hd">
                      <span class="title">
                        <template v-if="education.degree">
                          {{ $t('degree') }}:
                          {{education.degree}}
                        </template>
                        <template v-if="education.classOf">
                          , Class of {{education.classOf}}
                        </template>
                      </span>
                      <button class="btn btn_ic icon-pencil" @click="editEducation(education)"></button>
                      <button class="btn btn_ic icon-bin" @click="removeItemFromList(formattedPerson.educationInfoList, education)"></button>
                    </div>
                    <div class="col-12 col_txt_row" v-if="education.institution">
                      {{ $t('institution') }}:
                      {{ education.institution }}
                    </div>
                    <div class="col-12 col_txt_row" v-if="education.majorOne">Major: {{education.majorOne}}</div>
                    <div class="col-12 col_txt_row" v-if="education.majorTwo">Major Two: {{education.majorTwo}}</div>
                    <div class="col-12 col_txt_row" v-if="education.educationTimeLabel">Duration: {{education.educationTimeLabel}}</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="formattedPerson.educationInfoList && formattedPerson.educationInfoList.length === 0">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col">
                  <p class="text-center">
                    {{ $t('addEducationMsg') }}
                  </p>
                </div>
              </div>
            </template>


          </div>
        </div>
      </div>
    </template>
<!-- Education Ends -->

<!-- Certificates -->
    <div class="card crd_sty_3" v-if="learnerEnrollments.length > 0">
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">Certificates</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <div class="row">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col"
              v-for="(enrollment, index) in learnerEnrollments"
              :key="'enrollment-' + index">
              <div class="row">
                <div class="col-12 col_txt_row hd">
                  <span class="title">
                    <template v-if="enrollment.programTitle">{{ enrollment.programTitle }}</template>
                  </span>
                </div>
                <div class="col-12 col_txt_row" v-if="enrollment.status">
                  {{ $t('status') }}: {{ enrollment.status.toLowerCase() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- Certificates Ends -->


    <div class="card crd_sty_3">
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">
            {{ $t('programAndCareerInterest') }}
          </div>
        </div>
        <div class="col-2 lnk_container">
          <span>
            <a href="javascript://" @click="editProfileClicked">
              {{ $t('update') }}
            </a>
          </span>
        </div>
      </div>

      <div class="row pg_sec_content">
        <div class="col-12">
          <div class="row fld_row" v-for="(question, i) in questions">
            <div class="ic_container col-2">
              <div class="ic" :class="'ic-' + question.icon"></div>
            </div>
            <div class="col-10">
              <div class="row">
                <div class="col-6 fld_label">
                  <div>{{question.shortTitle}}</div>
                </div>
                <template v-if="question.type === 'SELECT'">
                  <template v-if="question.optionType === 'DYNAMIC'">
                    <div class="col-6 fld_val">
                      <div class="selected_entity" v-if="question.response">
                        <span :title="question.response">{{question.response}}</span>
                      </div>
                      <div class="no_info" v-else>
                        {{ $t('na') }}
                      </div>
                    </div>
                  </template>
                  <template v-if="question.optionType === 'STATIC'">
                    <div class="col-6 fld_val">
                      <div class="selected_entity" v-if="question.response">
                          <span :title="question.response">{{question.response}}</span>
                      </div>
                      <div class="no_info" v-else>
                        {{ $t('na') }}
                      </div>
                    </div>
                  </template>
                  <template v-if="question.optionType === 'STATIC-MULTI'">
                    <div class="col-6 fld_val">
                      <div v-if="question.selectedResponses && question.selectedResponses.length > 0">
                        <div class="selected_entity" v-for="sR in question.selectedResponses">
                          <span :title="sR">{{sR}}</span>
                        </div>
                      </div>
                      <div class="no_info" v-else>
                        {{ $t('na') }}
                      </div>
                    </div>
                  </template>
                  <template v-if="question.optionType === 'DYNAMIC-MULTI'">
                    <div class="col-6 fld_val">
                      <div v-if="question.selectedResponses && question.selectedResponses.length > 0">
                        <div class="selected_entity" v-for="sR in question.selectedResponses" v-if="sR">
                          <span :title="sR">{{sR}}</span>
                        </div>
                      </div>
                      <div class="no_info" v-else>
                        {{ $t('na') }}
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else-if="question.type === 'MULTI_LINE_TEXT'">
                  <div class="col-6 fld_val">
                    <textarea :rows="question.lineCount" cols="50" :maxlength="question.responseLimit" v-model.trim="question.response" :disabled="true"></textarea>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		
    <learner-profile-question ref="learnerProfileQuestion"></learner-profile-question>

<!-- Password Modal -->
		<b-modal class="h-100 d-inline-block" ref="changePasswordModal" size="xl" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
			<div slot="modal-header" class="header-section w-100">
        <div class="popup_head_txt float-left">
          <div class="module_icon icon-user float-left mr-3 mt-1"></div>
					<label class="head_txt module_type_name">
						{{ $t('changePasswordTitle') }}
					</label>
        </div>
        <div class="float-right">
          <button
						@click="cancelChangePasswordModal"
						class="btn_close"
						:aria-label="$t('closeAria')"
						:title="$t('closeTitle')"
						v-b-tooltip.hover>
            	<span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="modal_content">
      	<user-settings ref="userSettings" :uuid="uuid" :show-in-modal="true"></user-settings>
      </div>
		</b-modal>
<!-- Password Modal Ends -->
<!-- Contact Info Modal -->
		<b-modal class="h-100 d-inline-block" ref="contactInfoModal" size="xl" :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
			<div slot="modal-header" class="header-section w-100">
        <div class="popup_head_txt float-left">
          <div class="module_icon icon-user float-left mr-3 mt-1"></div>
					<label class="head_txt module_type_name">
						{{ $t('updateContactInfoTitle') }}
					</label>
        </div>
        <div class="float-right">
          <button
						@click="cancelContactInfoModal"
						class="btn_close"
						:aria-label="$t('closeAria')"
						:title="$t('closeTitle')"
						v-b-tooltip.hover>
            	<span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="modal_content">
      	<user-contact-info ref="userContactInfo" @saved="onContactInfoSaved"></user-contact-info>
      </div>
		</b-modal>
<!-- Contact Info Modal Ends -->    
<!-- Employer Visibility Modal -->
    <b-modal class="h-100 d-inline-block" ref="changeVisibilityModal"  :header-bg-variant="'light'" hide-footer no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header" class="header-section w-100">
        <div class="popup_head_txt float-left">
          <div class="module_icon icon-user float-left mr-3 mt-1"></div>
          <label class="head_txt module_type_name" v-if="visibilityValue">
            Make Visible to Employer
          </label>
          <label class="head_txt module_type_name" v-else>
            Make Not Visible to Employer
          </label>

        </div>
        <div class="float-right">
          <button
            @click="closeVisibilityModal"
            class="btn_close"
            :aria-label="$t('closeAria')"
            :title="$t('closeTitle')"
            v-b-tooltip.hover>
              <span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="modal_content">
        <div class="row fld_row">
          <div class="col-12 fld_col_label" style="text-align: center;">
            <template v-if="visibilityValue">
            Your {{visibilityType}} will be visible to Employers. Is that ok?
            </template>
            <template v-else>
            Your {{visibilityType}} will not be visible to Employers. Is that ok?
            </template>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="saveVisibility" class="btn button-primary float-right mr-2">{{ $t('yes') }}</b-button>
          <b-button @click="closeVisibilityModal" class="btn button-primary float-right mr-2">{{ $t('no') }}</b-button>          
        </div>
      </div>
    </b-modal>
<!-- End Employer Visibility Modal -->        
<!-- Education Modal -->
    <b-modal ref="modal" id="addNewEducation" v-model="showAddEducationModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
    <div slot="modal-header" class="popover-header">
        <div class="popup-heading">Education</div>
        <button
          @click="cancelAddNewEducation"
          class="btn_close"
          :aria-label="$t('closeAria')"
          :title="$t('closeTitle')"
          v-b-tooltip.hover>
            <span class="ic-close"></span>
        </button>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newInstitutionName"> Institution <span class="fld_req">*</span></label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newInstitutionName" v-model="newInstitutionName" placeholder="name of institution"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newDegree"> Degree <span class="fld_req">*</span></label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newDegree" v-model="newDegree" placeholder="academic degree or diploma"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newGraduationYear"> Class of <span class="fld_req">*</span></label>
            </div>
        <div class="col-8 fld_col_input">
          <select id="newGraduationYear" v-model="newGraduationYear">
              <option v-for="year in years" v-model="newGraduationYear">
                  {{ year }}
                </option>
          </select>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newMajorOne">Major <span class="fld_req">*</span></label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newMajorOne" v-model="newMajorOne" placeholder="primary field of study"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newMajorTwo">Second Major</label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newMajorTwo" v-model="newMajorTwo" placeholder="other primary field of study (if any)"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newMinor">Minor</label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newMinor" v-model="newMinor" placeholder="secondary field of study"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newConcentration">Concentration</label>
            </div>
        <div class="col-8 fld_col_input">
          <input id="newConcentration" v-model="newConcentration" placeholder="area of specialization"></input>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newEducationStart">Start <span class="fld_req">*</span></label>
            </div>
        <div class="col-4 fld_col_input">
          <select id="newEducationStartMonth" v-model="newEducationStartMonth">
                  <option v-for="month in months" v-model="newEducationStartMonth">
                    {{ month }}
                  </option>
              </select>
        </div>
        <div class="col-4 fld_col_input">
          <select id="newEducationStartYear" v-model="newEducationStartYear">
                  <option v-for="year in years" v-model="newEducationStartYear">
                    {{ year }}
                  </option>
              </select>
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label">
          <label for="newEducationEnd">End <span class="fld_req">*</span></label>
            </div>
        <div class="col-4 fld_col_input" v-if="!isPursuingEducation">
          <select id="newEducationEndMonth" v-model="newEducationEndMonth">
                  <option v-for="month in months" v-model="newEducationEndMonth">
                    {{ month }}
                  </option>
              </select>
        </div>
        <div class="col-4 fld_col_input" v-if="!isPursuingEducation">
          <select id="newEducationEndYear" v-model="newEducationEndYear">
                  <option v-for="year in years" v-model="newEducationEndYear">
                    {{ year }}
                  </option>
              </select>
        </div>
        <div class="col-8 fld_col_label" style="text-align: left;" v-else>
              - Present
        </div>
      </div>

      <div class="row fld_row">
        <div class="col-3 fld_col_label" style="text-align: right;">
          <input type="checkbox" id="pursuingCheckbox" v-model="isPursuingEducation">
            </div>
        <div class="col-8 fld_col_label" style="text-align: left;">
          <label for="pursuingCheckbox">Currently pursuing</label>
        </div>
      </div>

      <div slot="modal-footer">
        <b-button-group>
          <span v-if="errors && errors.length > 0">{{errors}}</span>
          <b-btn @click="cancelAddNewEducation">
            cancel
          </b-btn>
          <b-btn @click="addNewEducation">
            save
          </b-btn>
        </b-button-group>
      </div>
    </b-modal>
<!-- End Education Modal -->
<!-- Experience Modal -->
     <b-modal ref="modal" id="addNewExperience" v-model="showAddExperienceModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
        <div slot="modal-header" class="popover-header">
          <div class="popup-heading">
            {{ $t('experience') }}
          </div>
          <button
            @click="cancelAddNewExperience"
            class="btn_close"
            :aria-label="$t('closeAria')"
            :title="$t('closeTitle')"
            v-b-tooltip.hover>
             <span class="ic-close"></span>
          </button>
         </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newJobTitle">
              {{ $t('jobTitle') }}
              <span class="fld_req">*</span>
            </label>
          </div>
          <div class="col-8 fld_col_input">
            <input
              id="newJobTitle"
              v-model="newJobTitle"
              :placeholder="$t('typeInJobTitlePH')">
            </input>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newJobDescription">
              {{ $t('description') }}
            </label>
          </div>
          <div class="col-8 fld_col_input">
            <input
              id="newJobDescription"
              v-model="newJobDescription"
              :placeholder="$t('typeInJobDescPH')">
            </input>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newJobEmployer">
              {{ $t('employer') }}
              <span class="fld_req">*</span>
            </label>
          </div>
          <div class="col-8 fld_col_input">
            <input
              id="newJobEmployer"
              v-model="newEmployer"
              :placeholder="$t('typeInEmployerPH')">
            </input>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newJobIndustry">
              {{ $t('industry') }}
              <span class="fld_req">*</span>
            </label>
          </div>
          <div class="col-8 fld_col_input">
            <input
              id="newJobIndustry"
              v-model="newIndustry"
              :placeholder="$t('typeInIndustryPH')">
            </input>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newJobLocation">
              {{ $t('location') }}
              <span class="fld_req">*</span>
            </label>
          </div>
          <div class="col-8 fld_col_input">
            <input
              id="newJobLocation"
              v-model="newExperienceLocation"
              placeholder="type in job location">
            </input>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newExperienceStart">
              {{ $t('start') }}
              <span class="fld_req">*</span>
            </label>
           </div>
          <div class="col-4 fld_col_input">
            <select id="newExperienceStartMonth" v-model="newExperienceStartMonth">
              <option v-for="month in months" v-model="newExperienceStartMonth">
                {{ month }}
              </option>
            </select>
          </div>
          <div class="col-4 fld_col_input">
            <select id="newExperienceStartYear" v-model="newExperienceStartYear">
              <option v-for="year in years" v-model="newExperienceStartYear">
                {{ year }}
              </option>
            </select>
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <label for="newExperienceEnd">
              {{ $t('end') }}
              <span class="fld_req">*</span>
            </label>
          </div>
          <div class="col-4 fld_col_input" v-if="!isPursuingExperience">
            <select id="newExperienceEndMonth" v-model="newExperienceEndMonth">
                <option v-for="month in months" v-model="newExperienceEndMonth">
                  {{ month }}
                </option>
            </select>
          </div>
          <div class="col-4 fld_col_input" v-if="!isPursuingExperience">
            <select id="newExperienceEndYear" v-model="newExperienceEndYear">
                <option v-for="year in years" v-model="newExperienceEndYear">
                  {{ year }}
                </option>
            </select>
          </div>
          <div v-else class="col-8 fld_col_label" style="text-align: left;">
            - {{ $t('present') }}
          </div>
        </div>

        <div class="row fld_row">
          <div class="col-3 fld_col_label">
            <input type="checkbox" id="pursuingCheckbox" v-model="isPursuingExperience">
          </div>
          <div class="col-8 fld_col_label" style="text-align: left;">
            <label for="pursuingCheckbox">
              {{ $t('currentlyWorking') }}
            </label>
          </div>
        </div>

        <div slot="modal-footer">
          <b-button-group>
            <span v-if="errors && errors.length > 0">{{errors}}</span>
            <b-btn @click="cancelAddNewExperience">
              cancel
            </b-btn>
            <b-btn @click="addNewExperience">
              save
            </b-btn>
          </b-button-group>
        </div>
     </b-modal>
<!-- End Experience Modal -->
	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import { PACKAGE } from '../../../package_constants'
	import LearnerProfileResume from './LearnerProfileResume'
	import LearnerProfileQuestion from './LearnerProfileQuestion'
	import UserSettings from '../../user/components/UserSettings'
	import UserContactInfo from '../../user/components/UserContactInfo'
	import { StorageFactory } from '../../../storageFactory'
  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-profile',
		components: {
			UserSettings,
			UserContactInfo,
			LearnerProfileResume,
      LearnerProfileQuestion
    },
		data: () => {
			return {
        visibilityType : '',
        visibilityValue: false,
				questions: [],
				userObject: JSON.parse(localStore.getItem('userobj')),
        showAddExperienceModal: false,
        showAddEducationModal: false,
        newJobTitle: '', // fields for adding new Experience
        newJobDescription: '',
        newEmployer: '',
        newIndustry: '',
        newExperienceLocation: '',
        newExperienceStartMonth: '',
        newExperienceStartYear: '',
        newExperienceEndMonth: '',
        newExperienceEndYear: '',
        newInstitutionName: '', // fields for adding new Education
        newDegree: '',
        newGraduationYear: '',
        newMajorOne: '',
        newMajorTwo: '',
        newMinor: '',
        newConcentration: '',
        newEducationStartMonth: '',
        newEducationStartYear: '',
        newEducationEndMonth: '',
        newEducationEndYear: '',
        isPursuingExperience: false,
        isPursuingEducation: false,
        errors: [],
        years: ['1970', '1971', '1972', '1973', '1974', '1975', '1976', '1977', '1978', '1979', '1980', '1981', '1982', '1983', '1984', '1985', '1986', '1987', '1988', '1989', '1990', '1991', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthMap: {
          0: 'January',
          1: 'February',
          2: 'March',
          3: 'April',
          4: 'May',
          5: 'June',
          6: 'July',
          7: 'August',
          8: 'September',
          9: 'October',
          10: 'November',
          11: 'December'
        }
			}
		},
		computed: {
			...mapState({
				'enabledFeatures': state => state.institution.enabledFeatures,
        'person': state => state.person.personObject,
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
			}),
			uuid () {
				return this.userObject.uuid
			},
    	email () {
        return this.userObject.eMail
      },
      phone () {
        return this.userObject.primaryPhoneNumber || this.$t('na')
      },
      linkedIn () {
        return this.userObject.linkedIn || this.$t('na')
      },
      address () {
        let address = ''
        address += this.userObject.street?this.userObject.street:''
        address += this.userObject.city?' '+this.userObject.city:''
        address += this.userObject.state?' '+this.userObject.state:''
        address += this.userObject.country?' '+this.userObject.country:''
        address += this.userObject.zip?' '+this.userObject.zip:''
        return address || this.$t('na')
      },

			userName () {
        return this.userObject.firstName + ' ' + this.userObject.lastName
      },
      isResumeUploadEnabled () {
      	let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
          	return (flag.title === 'learnerCanUploadResume')
          })
          return found ? found.enabled : false
        }
        return false
      },
      isEditExperienceEnabled () {
      	let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
          	return (flag.title === 'learnerCanEditExperience')
          })
          return found ? found.enabled : false
        }
        return false
      },
      isEditEducationEnabled () {
      	let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
          	return (flag.title === 'learnerCanEditEducation')
          })
          return found ? found.enabled : false
        }
        return false
      },
      formattedPerson () {
        let formattedPerson = this.userObject.userProfile
        if (!formattedPerson) {
          return {}
        }
        let buildTimeRangeLabel = this.buildTimeRangeLabel
        if (formattedPerson.experienceInfoList) {
          formattedPerson.experienceInfoList.forEach(experience => {
            experience.experienceTimeLabel = buildTimeRangeLabel(experience.from, experience.to)
          })
        }
        if (formattedPerson.educationInfoList) {
          formattedPerson.educationInfoList.forEach(education => {
            education.educationTimeLabel = buildTimeRangeLabel(education.from, education.to)
          })
        }
        return formattedPerson
      },
      learnerEnrollments () {
        return this.learnerEnrollmentData || []
      }
		},
		created () {
			this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateProfileQuestionData()
	    })
	    this.$root.$on('closeChangePasswordModal', () => {
	      this.cancelChangePasswordModal()
	    })
	    this.$root.$on('closeContactInfoModal', () => {
	      this.cancelContactInfoModal()
	    })
		},
    watch: {
      isPursuingEducation (newIsPursuingEducation) {
        if (newIsPursuingEducation) {
          this.newEducationEndMonth = ''
          this.newEducationEndYear = ''
        }
      },
      isPursuingExperience (newIsPursuingExperience) {
        if (newIsPursuingExperience) {
          this.newExperienceEndMonth = ''
          this.newExperienceEndYear = ''
        }
      }
    },
		mounted () {
			this.$parent.$refs.loadingModal.show()
			this.populateProfileQuestionData()
      this.setupPersonProfile()
      this.loadLearnerEnrollmentData(this.uuid)
    },
		methods: {
			...mapActions([
				'loadMajorMinor',
        'loadCareerByCode',
        'loadQuestionsForGroup',
        'loadSaveUserProfile',
        'loadLearnerEnrollmentData'
	    ]),
      async setupPersonProfile () {
      },
      isValidYearFormat (yearString) {
        // TODO
        return true
      },
      buildTimeRangeLabel (from, to) {
        let monthMap = this.monthMap // maps 0 -> Jan, 1 -> Feb, ....
        // string 'from' is guaranteed to be set from the backend, checking in case
        if (!from) {
          return ''
        }

        // create label prefix in human readable date format instead of UTC
        let dateTime = new Date(from)
        let label = monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear() + ' - '

        if (to && !(to instanceof Date)) {
          dateTime = new Date(to)
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else if (to && to instanceof Date && !isNaN(to.getMonth())) { // date is valid
          dateTime = to
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else {
          label += 'Present'
        }
        return label
      },
      addExperienceClicked () {
        this.showAddExperienceModal = true
      },
      showVisibilityModal (attributeName, attributeValue){
        this.visibilityType = attributeName
        this.visibilityValue = attributeValue
        this.$refs.changeVisibilityModal.show()
      },
      async saveVisibility(){
          if(this.visibilityType==='Experiences'){
              this.formattedPerson.experienceVisibleToEmployer = this.visibilityValue
          }
          if(this.visibilityType==='Educations'){
              this.formattedPerson.educationVisibleToEmployer = this.visibilityValue
          }
          if(this.visibilityType==='Resume'){
              this.formattedPerson.resumeVisibleToEmployer = this.visibilityValue
              let resumeComponent = this.$refs.learnerProfileResume
              if (resumeComponent && resumeComponent.userObject && resumeComponent.userObject.userProfile) {
                resumeComponent.userObject.userProfile.resumeVisibleToEmployer = this.visibilityValue
              }
          }
          await this.loadSaveUserProfile({userProfile: this.formattedPerson})
          this.closeVisibilityModal()
      },
      closeVisibilityModal () {
        this.$refs.changeVisibilityModal.hide()
      },
      addEducationClicked () {
        this.showAddEducationModal = true
      },
      async addNewExperience () {
        if (!this.newJobTitle || !this.newEmployer || !this.newIndustry || !this.newExperienceLocation || !this.newExperienceStartMonth || !this.newExperienceStartYear) {
          this.errors = 'Fields marked with * are required'
          return
        }
        if (!this.datesRangeIsValid(this.newExperienceStartMonth, this.newExperienceStartYear, this.newExperienceEndMonth, this.newExperienceEndYear)) {
          this.errors = 'End Date cannot be before Start Date'
          return
        }
        this.errors = []
        this.newExperience = {
          title: this.newJobTitle,
          pragyaTitle: null,
          description: this.newJobDescription,
          employer: this.newEmployer,
          location: this.newExperienceLocation,
          locationCountry: null,
          industry: this.newIndustry,
          pragyaIndustry: null,
          career: null,
          from: new Date(this.newExperienceStartMonth + '1, ' + this.newExperienceStartYear),
          to: (this.newExperienceEndMonth) ? new Date(this.newExperienceEndMonth + '1, ' + this.newExperienceEndYear) : ''
        }

        // build human readable time string based on dates entered
        let from = this.newExperience.from
        let to = this.newExperience.to
        this.newExperience.experienceTimeLabel = this.buildTimeRangeLabel(from, to)

        if (this.isEditing) {
          // Vue 2.0 requires us to replace the entire array instead of a single entry
          let newExperienceInfoList = []
          this.formattedPerson.experienceInfoList.forEach(item => {
            if (item.title === this.newExperience.title) {
              newExperienceInfoList.push(this.newExperience)
            } else {
              newExperienceInfoList.push(item)
            }
          })
          this.formattedPerson.experienceInfoList = newExperienceInfoList
          this.isEditing = false
        } else {
          this.formattedPerson.experienceInfoList.push(this.newExperience)
          this.newExperience = {}
        }

        await this.loadSaveUserProfile({userProfile: this.formattedPerson})

        // clear the fields and close the modal
        this.cancelAddNewExperience()
      },
      async addNewEducation () {
        if (!this.newInstitutionName || !this.newDegree || !this.newGraduationYear || !this.newMajorOne || !this.newEducationStartMonth || !this.newEducationStartYear) {
          this.errors = 'Fields marked with * are required'
          return
        }
        if (!this.datesRangeIsValid(this.newEducationStartMonth, this.newEducationStartYear, this.newEducationEndMonth, this.newEducationEndYear)) {
          this.errors = 'End Date cannot be before Start Date'
          return
        }
        this.errors = []

        console.log("Date:", this.newEducationStartMonth )
        console.log("Date:", this.newEducationStartYear )
        console.log("Date:", new Date(this.newEducationStartMonth + '1, ' + this.newEducationStartYear) )
        this.newEducation = {
          degree: this.newDegree,
          classOf: this.newGraduationYear,
          majorOne: this.newMajorOne,
          majorTwo: this.newMajorTwo,
          minor: this.newMinor,
          institution: this.newInstitutionName,
          concentration: this.newConcentration,
          startYear: new Date(this.newEducationStartMonth + '1, ' + this.newEducationStartYear),
          finishYear: (this.newEducationEndMonth) ? new Date(this.newEducationEndMonth + '1, ' + this.newEducationEndYear) : ''
        }

        // build human readable time string based on dates entered
        let from = this.newEducation.startYear
        let to = this.newEducation.finishYear
        this.newEducation.educationTimeLabel = this.buildTimeRangeLabel(from, to)

        // TODO
        if (this.isEditing) {
          // Vue 2.0 requires us to replace the entire array instead of a single entry
          let newEducationInfoList = []
          this.formattedPerson.educationInfoList.forEach(item => {
            if (item.institution === this.newEducation.institution) {
              newEducationInfoList.push(this.newEducation)
            } else {
              newEducationInfoList.push(item)
            }
          })
          this.formattedPerson.educationInfoList = newEducationInfoList
          this.isEditing = false
        } else {
          this.formattedPerson.educationInfoList.push(this.newEducation)
          this.newEducation = {}
        }

        await this.loadSaveUserProfile({userProfile: this.formattedPerson})

        // clear the fields and close the modal
        this.cancelAddNewEducation()
      },
      datesRangeIsValid (startMonth, startYear, endMonth, endYear) {
        if (startMonth && startYear && !endMonth && !endYear) {
          return true
        }
        // TODO enforce that startYear and endYear are numeric and in 'YYYY' format
        if (!this.isValidYearFormat(startYear) || !this.isValidYearFormat(endYear)) {
          this.errors = 'Years must not be before 1970 and must be in YYYY format.'
        }
        return new Date(startMonth + '1, ' + startYear) < new Date(endMonth + '1, ' + endYear)
      },
      async editExperience (experience) {
        let from
        let to
        if (experience.from) {
          from = new Date(experience.from)
        }
        if (experience.to) {
          to = new Date(experience.to)
        }
        this.newJobTitle = experience.title
        this.newEmployer = experience.employer
        this.newIndustry = experience.industry
        this.newExperienceLocation = experience.location
        this.newJobDescription = experience.description
        this.newExperienceStartMonth = (from) ? this.monthMap[from.getMonth()] : ''
        this.newExperienceStartYear = (from) ? from.getFullYear() : ''
        this.newExperienceEndMonth = (to) ? this.monthMap[to.getMonth()] : ''
        this.newExperienceEndYear = (to) ? to.getFullYear() : ''
        this.showAddExperienceModal = true
        this.isEditing = true
        this.errors = []
      },
      editEducation (education) {
        let from
        let to
        if (education.startYear) {
          from = new Date(education.startYear)
        }
        if (education.finishYear) {
          to = new Date(education.finishYear)
        }

        this.newInstitutionName = education.institution
        this.newDegree = education.degree
        this.newGraduationYear = education.classOf
        this.newMajorOne = education.majorOne
        this.newMajorTwo = education.majorTwo
        this.newMinor = education.minor
        this.newConcentration = education.concentration
        this.newEducationStartMonth = (from) ? this.monthMap[from.getMonth()] : ''
        this.newEducationStartYear = (from) ? from.getFullYear() : ''
        this.newEducationEndMonth = (to) ? this.monthMap[to.getMonth()] : ''
        this.newEducationEndYear = (to) ? to.getFullYear() : ''
        this.showAddEducationModal = true
        this.isEditing = true
        this.errors = []
      },
      cancelAddNewExperience () {
        this.newJobTitle = ''
        this.newEmployer = ''
        this.newIndustry = ''
        this.newExperienceLocation = ''
        this.newJobDescription = ''
        this.newExperienceStartMonth = ''
        this.newExperienceStartYear = ''
        this.newExperienceEndMonth = ''
        this.newExperienceEndYear = ''
        this.showAddExperienceModal = false
        this.errors = []
      },
      cancelAddNewEducation () {
        this.newDegree = ''
        this.newGraduationYear = ''
        this.newMajorOne = ''
        this.newMajorTwo = ''
        this.newMinor = ''
        this.newInstitutionName = ''
        this.newConcentration = ''
        this.newEducationStartMonth = ''
        this.newEducationStartYear = ''
        this.newEducationEndMonth = ''
        this.newEducationEndYear = ''
        this.showAddEducationModal = false
        this.errors = []
      },
      async removeItemFromList (list, item) {
        list.splice(list.indexOf(item), 1)
        await this.loadSaveUserProfile({userProfile: this.formattedPerson})
      },
      async updateItemInList (list, item) {
        list.splice(list.indexOf(item), 1)
        await this.loadSaveUserProfile({userProfile: this.formattedPerson})
      },
	    populateProfileQuestionData () {
	    	this.questions = []
        this.loadQuestionsForGroup('PROFILE_POPUP_1').then(questions => {
	        _.forEach(questions, (question, index) => {
	        	let response = (question.responses && question.responses.length > 0) ? question.responses[0] : null
	        	if ((question.type === 'SELECT') || (question.type === 'MULTI_LINE_TEXT')) {
            	if ((question.optionSource === 'CAREER') || (question.optionSource === 'PROGRAM')) {
            		question.response = ''
            	} else {
            		question.response = response
            	}
            }
            if (question.optionType === 'STATIC') {
            		if(question.response ==='Other'){
                    question.response = question.responses[1]
                }
            }
            if (question.optionType === 'DYNAMIC') {
              if (question.optionSource === 'CAREER') {
              	this.loadCareerByCode(response).then(career => {
              		question.response = career.name
              	})
              } else if (question.optionSource === 'PROGRAM') {
              	this.loadMajorMinor({code: response}).then(program => {
              		question.response = program.name
              	})
              }
            }
            if (question.optionType === 'DYNAMIC-MULTI') {
              if (question.optionSource === 'CAREER') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadCareerByCode(item).then(career => {
                  		question.selectedResponses.push(career.name)
                  	})
                  })
                }
              } else if (question.optionSource === 'PROGRAM') {
                question.selectedResponses = []
                if (question.responses) {
                  question.responses.forEach((item, i) => {
                    this.loadMajorMinor({code: item}).then(program => {
                  		question.selectedResponses.push(program.name)
                  	})
                  })
                }
              }
            }
            if (question.optionType === 'STATIC-MULTI') {
                question.selectedResponses = []
                if(question.responses) {
	                question.responses.forEach((item, i) => {
	                		question.selectedResponses.push(item)
	                })
                }
            }

            this.questions.push(question)
        	})
        	setTimeout(() => {
        		this.$parent.$refs.loadingModal.hide()
        	}, 1000)
	      })
      },
      editProfileClicked () {
				this.$refs.learnerProfileQuestion.showAddProgCarIntModal()
			},
			showChangePasswordModal () {
				this.$refs.changePasswordModal.show()
			},
			cancelChangePasswordModal () {
				this.$refs.userSettings.reset()
				this.$refs.changePasswordModal.hide()
			},
			showContactInfoModal () {
				this.$refs.userContactInfo.loadFromUser(this.userObject)
				this.$refs.contactInfoModal.show()
			},
			cancelContactInfoModal () {
				if (this.$refs.userContactInfo) {
					this.$refs.userContactInfo.reset()
				}
				this.$refs.contactInfoModal.hide()
			},
			onContactInfoSaved (updatedUser) {
				if (updatedUser) {
					this.userObject = updatedUser
				}
			}
	  }
	}
</script>

<style scoped>
  .popup_head_txt {
    font-size: 1.4rem;
    font-weight: 600;
  }

  .visibility-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 28px;
    margin-left: 8px;
    padding: 0;
    border: 1px solid #4f7f3e;
    border-radius: 6px;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    vertical-align: middle;
  }

  .visibility-btn:before {
    margin: 0;
  }

  .visibility-btn:hover,
  .visibility-btn:focus {
    background: #eef5ea;
    color: #4f7f3e;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfile.vue